<template>
	<ModalGenericModal
		:title="title"
		:click-outside-enabled="true"
		container-class="rounded-lg w-full md:w-11/12"
		ref="baseModal">
		<div
			class="p-2 h-[80vh] md:h-[83vh] bg-popup-bg border-x-2 border-b-2 border-popup-border text-popup-text rounded-b-lg text-center">
			<div class="flex flex-col gap-4 m-full max-w-full h-full max-h-full">
				<!-- <div class="text-right">
					<ButtonIconThenText
						class="text-ternary text-xs hoverEffects viewDetails"
						:text="showHelp ? $t('helpHide') : $t('helpShow')"
						icon="fa-solid fa-circle-info"
						@clicked="expandHelp" />

					<transition name="slide-fade">
						<div
							v-if="showHelp"
							class="text-sm text-left"
							:class="{ 'leading-3 !text-right': !$utilities.$isMobileDevice() }">
							<div v-html="$utilities.$isMobileDevice() ? t('previewHelpMobile') : t('previewHelpDesktop')"></div>
						</div>
					</transition>
				</div> -->

				<div class="grow w-full h-full flex items-center justify-center overflow-hidden inverted-bg">
					<img
						ref="imageRef"
						class="max-w-full max-h-full object-contain"
						:src="imageSrc"
						alt="map" />
				</div>

				<div class="basis-xs">
					<ButtonModalClose
						:label="$t('close')"
						class="w-32"
						@click="closeModal" />
				</div>
			</div>
		</div>
	</ModalGenericModal>
</template>

<script setup>
	import Panzoom from "@panzoom/panzoom"

	// const { t } = useI18n()
	// const { $utilities } = useNuxtApp()

	defineProps({
		title: {
			type: String,
			required: true,
		},
		imageSrc: {
			type: String,
			required: true,
		},
	})

	const baseModal = ref(null)
	// const showHelp = ref(false)
	const imageRef = ref(null)
	const panzoomInstance = ref(null)

	// const expandHelp = () => {
	// 	showHelp.value = !showHelp.value
	// }

	const openModal = () => {
		baseModal.value?.openModal()
		nextTick(() => {
			const elem = imageRef.value
			panzoomInstance.value = Panzoom(elem, {
				maxScale: 5,
				minScale: 0.25,
			})

			//Listen for CTRL + scroll or CMD + scroll events
			elem.parentElement.addEventListener(
				"wheel",
				(e) => {
					if (e.ctrlKey || e.metaKey) {
						panzoomInstance.value.zoomWithWheel(e)
					}
				},
				{ passive: false }
			)
		})
	}

	const closeModal = () => {
		baseModal.value?.closeModal()
		// Clean up all Panzoom resources
		if (panzoomInstance.value) {
			panzoomInstance.value.destroy?.()
			panzoomInstance.value = null
		}
	}

	defineExpose({
		openModal,
	})
</script>

<style lang="scss" scoped>
	.inverted-bg {
		backdrop-filter: invert(15%);
	}
</style>
